import {AnalysisMainViewItem, ViewReference} from 'analysis-tool/ui/main-view/MainViewTypes';
import {CombineTablesMethod} from 'pipelines/joins/CombineTablesMethodSelector';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

export enum AnalysisRightSidebarItemType {
  ADD_SOURCE_STEP = 'ADD_SOURCE_STEP',
  ADD_STEP = 'ADD_STEP',
  COMBINE_TABLES_SOURCE = 'COMBINE_TABLES_SOURCE',
  EDIT_STEP = 'EDIT_STEP',
  EDIT_VIEW = 'EDIT_VIEW',
  LOOK_UP_SOURCE = 'LOOK_UP_SOURCE',
  THIRD_PARTY_IMPORT = 'THIRD_PARTY_IMPORT',
}

export type AnalysisRightSidebarItem<T extends AnalysisRightSidebarItemType = AnalysisRightSidebarItemType> =
  {type: T} & (
    | {type: AnalysisRightSidebarItemType.ADD_SOURCE_STEP}
    | {type: AnalysisRightSidebarItemType.ADD_STEP; stepId: string; stepDataName: string}
    | {type: AnalysisRightSidebarItemType.COMBINE_TABLES_SOURCE; initialCombineMethod: CombineTablesMethod}
    | {type: AnalysisRightSidebarItemType.EDIT_STEP; stepId: string}
    | {type: AnalysisRightSidebarItemType.LOOK_UP_SOURCE}
    | {
        type: AnalysisRightSidebarItemType.EDIT_VIEW;
        viewReference: ViewReference;
        // isUpdating is in the RightSidebarItem because we have to update it at the same time as the new viewReference
        // or there might be race conditions with out of sync analyses and viewReferences.
        isUpdating?: true;
      }
    | {type: AnalysisRightSidebarItemType.THIRD_PARTY_IMPORT}
  );

/**
 * Utility type to narrow down `AnalysisRightSidebarItemType` to a specific subtype based on the `type` key.
 */
export type GenericAnalysisRightSidebarItem<T extends AnalysisRightSidebarItemType> = Extract<
  AnalysisRightSidebarItem<T>,
  {type: T}
>;

export interface RightSidebarComponentProps<T extends AnalysisRightSidebarItemType> {
  analysis: PipelineGraphQL;
  selectedRightSidebarItem: GenericAnalysisRightSidebarItem<T>;
  onChangeSelectedRightSidebarItem: (newSelectedRightSidebarItem: AnalysisRightSidebarItem | null) => void;
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem | null) => void;
  clientStateId: string;
}
